import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {GenerateRecapRequest, GenerateRecapResponse} from './types'

export async function apiGenerateRecap(params: GenerateRecapRequest): Promise<GenerateRecapResponse> {
  const apiData = getApiMetadata('scribe-recaps-api-data')
  const url = new URL(apiData.url, window.location.origin)

  const body: Record<string, unknown> = {
    project_number: params.projectNumber,
    owner_type: params.ownerType,
    owner_id: params.ownerIdentifier,
    filter_query: params.filterQuery,
  }

  if (params.promptOptions) {
    body.prompt_options = params.promptOptions
  }

  const {data} = await fetchJSONWith<GenerateRecapResponse>(url.toString(), {
    method: 'POST',
    body,
  })

  return data
}
